import React from 'react';
import Icon from '../../../components/AppIcon';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date()?.getFullYear();

  const footerLinks = {
    navigation: [
      { label: 'Home', path: '/home-landing' },
      { label: 'Projects', path: '/projects' },
      { label: 'Blog', path: '/blog-posts' },
      { label: 'About', path: '/about' }
    ],
    services: [
      { label: 'Threat Analyst Engineer', path: '/services/web-development' },
      { label: 'Consulting', path: '/services/consulting' },
      { label: 'Code Review', path: '/services/code-review' }
    ],
    legal: [
      { label: 'Privacy Policy', path: '/privacy' },
      { label: 'Terms of Service', path: '/terms' },
      { label: 'Cookie Policy', path: '/cookies' }
    ]
  };

  const socialIcons = [
    { name: 'Github', url: 'https://github.com/CySec-JoeSchmo/' },
    { name: 'Linkedin', url: 'https://www.linkedin.com/in/joseph-graziano-34a44530/' },
    { name: 'Twitter', url: 'https://twitter.com/TheGrazIT' },
    { name: 'Mail', url: 'mailto:joseph@joegraziano.ca' }
  ];

  return (
    <footer className="bg-slate-900 text-gray-300 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-8 md:mb-12">
          <div className="lg:col-span-1">
            <div className="flex gap-3">
              {socialIcons?.map((social) => (
                <a
                  key={social?.name}
                  href={social?.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center hover:bg-accent transition-colors duration-300"
                  aria-label={social?.name}
                >
                  <Icon name={social?.name} size={18} color="currentColor" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-base md:text-lg font-semibold text-white mb-4">
              Navigation
            </h3>
            <ul className="space-y-3">
              {footerLinks?.navigation?.map((link) => (
                <li key={link?.path}>
                  <Link
                    to={link?.path}
                    className="text-sm md:text-base text-gray-400 hover:text-accent transition-colors duration-300"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-base md:text-lg font-semibold text-white mb-4">
              Legal
            </h3>
            <ul className="space-y-3 mb-6">
              {footerLinks?.legal?.map((link) => (
                <li key={link?.path}>
                  <Link
                    to={link?.path}
                    className="text-sm md:text-base text-gray-400 hover:text-accent transition-colors duration-300"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400 text-center md:text-left">
              © {currentYear}. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;